import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { settingsMenuAnimations } from "@/_utility/animations";
import { isAsapAccount } from "@/_models/account.interface";
import { shareReplay, takeUntil } from "rxjs/operators";
import { Observable, Subject, combineLatest } from "rxjs";
import { UserService } from "@/_services";
import UserModel = UserDm.UserModel;
import { UserDm } from "@/_models";
import { OnboardingGuideService } from "@/_services/onboarding-guide.service";
import { USER_IS_AT_LEAST_ADMIN } from "@/_services";

@Component({
    selector: "app-mobile-menu",
    templateUrl: "./mobile-menu.component.html",
    styleUrls: ["./mobile-menu.component.scss"],
    animations: settingsMenuAnimations,
})
export class MobileMenuComponent implements OnInit, OnDestroy {
    currentUser$: Observable<UserModel>;
    isAdmin$: Observable<boolean>;
    asapFormId$: Observable<string | null>;
    showOnboardingButton = false;
    private destroy$ = new Subject<void>();
    isMenuOpened: boolean;
    isAsap = false;

    constructor(
        private userService: UserService,
        private onboardingGuideService: OnboardingGuideService,
        @Inject(USER_IS_AT_LEAST_ADMIN)
        isAdmin$: Observable<boolean>,
    ) {
        this.isAdmin$ = isAdmin$;
    }

    ngOnInit() {
        this.currentUser$ = this.userService
            .getCurrentUserAsync()
            .pipe(shareReplay());

        this.asapFormId$ = this.onboardingGuideService.asapFormId$;

        combineLatest([this.currentUser$, this.isAdmin$])
            .pipe(takeUntil(this.destroy$))
            .subscribe(([user, isAdmin]) => {
                this.isAsap = isAsapAccount(user.account);
                const dismissed = user?.dismissedBanners || [];

                const bannerKey = "onboardingGuide";
                const hasNotDismissed = !dismissed.includes(bannerKey);

                this.showOnboardingButton =
                    this.isAsap || (isAdmin && hasNotDismissed);

                if (this.showOnboardingButton) {
                    const steps =
                        this.onboardingGuideService.getStepsSnapshot();
                    if (steps.length === 0) {
                        this.onboardingGuideService.refresh().subscribe();
                    }
                }
            });
    }

    toggleMenu(state: boolean) {
        this.isMenuOpened = state;
    }

    onOnboardingDismiss() {
        this.showOnboardingButton = false;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    isOnboardingCompleted(): boolean {
        const steps = this.onboardingGuideService.getStepsSnapshot();
        return steps.length > 0 && steps.every((step) => step.completed);
    }
}
